import { dynamicElementsFancyList } from '@epicuro-next/constants/dynamic-elements';

export const defaultDetailsPowerConfig = {
  items: [
    {
      contentTypeId: dynamicElementsFancyList,
    },
  ],
};
